import radioChartTable from 'trunks/vue/admin/components/report/radio_chart_table.js';
import ratingChartTable from 'trunks/vue/admin/components/report/rating_chart_table.js';

export default Vue.extend({
  components: {
    'radio-chart-table': radioChartTable,
    'rating-chart-table': ratingChartTable,
  },

  props: {
    messageGID: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      selectionFields: [],
      ratingFields: [],
    };
  },

  template: `
    <div class="chart-container">
      <radio-chart-table v-for="field in selectionFields" :key='field.id' :field='field'/>
      <rating-chart-table v-for="field in ratingFields" :key='field.id' :field='field'/>
    </div>
  `,

  created() {
    this.createHorizontalChartView();
    this.createChartView();
  },

  methods: {
    createHorizontalChartView() {
      const formId = location.pathname.match(/admin\/forms\/(\d+)/)[1];
      const requestUrl = `/admin/forms/${formId}/report.json?page=1&data=selection&sort=default`;
      Skylark.Libs.Ajax.get(requestUrl, {
        responseType: 'json',
        success: (data) => {
          this.selectionFields = data.fields;
        },
      });
    },

    createChartView() {
      const formId = location.pathname.match(/admin\/forms\/(\d+)/)[1];
      const requestUrl = `/admin/forms/${formId}/report.json?page=1&data=rating&sort=default`;
      Skylark.Libs.Ajax.get(requestUrl, {
        responseType: 'json',
        success: (data) => {
          this.ratingFields = data.fields;
        },
      });
    },
  },
});
